import React, { useState } from 'react';
import './PYQs.css';
import { Link } from 'react-router-dom';
import pyqMobileImg from './image/prrepx_pyq0.png';
import pdfpageJpg from './image/pdfpage.jpg';

import SocialSidebar from "../components/SocialSideBar";

const pyqData = {
  Physics: [
    'Kinematics',
    'Laws of Motion',
    'Work, Power & Energy',
    'Rotational Motion',
    'Gravitation',
    'Waves & Sound',
    'Thermodynamics',
    'Optics',
    'Modern Physics',
    'Electrostatics',
    'Current Electricity',
  ],
  Chemistry: [
    'Some Basic Concepts of Chemistry',
    'Atomic Structure',
    'Chemical Bonding',
    'Equilibrium',
    'Thermodynamics',
    'Organic Chemistry Basics',
    'Hydrocarbons',
    'Haloalkanes and Haloarenes',
    'Environmental Chemistry',
    'Coordination Compounds',
  ],
  Mathematics: [
    'Sets, Relations & Functions',
    'Complex Numbers',
    'Logarithms',
    'Quadratic Equations',
    'Sequences & Series',
    'Binomial Theorem',
    'Matrices & Determinants',
    'Limits, Continuity & Differentiability',
    'Integral Calculus',
    'Differential Equations',
    'Probability',
  ]
};

const PYQs = () => {
  const [selectedSubject, setSelectedSubject] = useState('Physics');

  return (
    <div className="pyq-page">
      <SocialSidebar />

      {/* ── Hero (matches StudyMaterial page layout) ── */}
      <div className="pyq-hero" style={{ backgroundImage: `url(${pdfpageJpg})` }}>
        <div className="pyq-glow pyq-glow-1" />
        <div className="pyq-glow pyq-glow-2" />
        <div className="pyq-glow pyq-glow-3" />

        {/* Mobile image — shown on mobile, hidden on desktop/tablet */}
        <div className="pyq-hero-mobile-img">
          <img src={pyqMobileImg} alt="PYQ Papers" className="pyq-hero-mobile-slide-img" />
          <div className="pyq-hero-mobile-badge">📝 Chapter-Wise PYQ Papers — Free</div>
        </div>

        {/* Center — text content */}
        <div className="pyq-hero-content">
          <div className="pyq-badge-pill">📝 Chapter-Wise PYQ Papers · Free</div>
          <h1 className="pyq-hero-heading">
            <span className="pyq-title-blue">Previous Year Questions</span>
            <br />
            <span className="pyq-title-accent">IIT-JEE &amp; NEET — Chapter-Wise</span>
          </h1>
          <p className="pyq-hero-tagline">
            Explore IIT-JEE &amp; NEET previous year questions — carefully
            organised chapter-by-chapter for{" "}
            <strong>Physics, Chemistry &amp; Mathematics</strong>.
            Identify weak areas and boost exam confidence.
          </p>
          <div className="pyq-trust-row">
            <span className="pyq-trust-pill">✓&nbsp;IIT-JEE</span>
            <span className="pyq-trust-pill">✓&nbsp;NEET</span>
            <span className="pyq-trust-pill">✓&nbsp;Chapter-Wise</span>
            <span className="pyq-trust-pill">✓&nbsp;Free</span>
          </div>
          <p className="pyq-alumni-text">✨ Physics · Chemistry · Mathematics — All Chapter-Wise & Free</p>
        </div>

        <div className="pyq-scroll-hint">
          <span>Scroll to explore</span>
          <div className="pyq-scroll-arrow" />
        </div>
      </div>

      {/* ── Content ── */}
      <div className="pyq-container">

      <div className="subject-buttons">
        {Object.keys(pyqData).map(subject => (
          <button
            key={subject}
            className={`subject-btn ${selectedSubject === subject ? 'active' : ''}`}
            onClick={() => setSelectedSubject(subject)}
          >
            {subject}
          </button>
        ))}
      </div>

      <div className="chapter-grid">
        {pyqData[selectedSubject].map((chapter, index) => {
          const chapterSlug = chapter.toLowerCase().replace(/[^a-z0-9]+/g, '-');
          const linkPath = `/pyqs/${selectedSubject.toLowerCase()}/${chapterSlug}`;

          return (
            <div key={index} className="chapter-card">
              <div className="chapter-title">{chapter}</div>
              <Link to={linkPath} className="view-pyq-btn">View PYQs</Link>
            </div>
          );
        })}
      </div>
      </div>
    </div>
  );
};

export default PYQs;
